import { useState } from 'react'

export const usePersonsTableSorting = (personsActions) => {
  const [sortField, setSortField] = useState()
  const [sortAsc, setSortAsc] = useState(true)
  const [genderSortFieldIndex, setGenderSortFieldIndex] = useState(-1)
  const [lifespanSortFieldIndex, setLifespanSortFieldIndex] = useState(-1)

  const genderSortFields = ['UNKNOWN_GENDER_FIRST', 'FEMALE_FIRST', 'MALE_FIRST']
  const lifespanSortFields = ['LIFESPAN_BEGIN_ASC', 'LIFESPAN_BEGIN_DESC', 'NO_LIFESPAN_BEGIN_FIRST']

  const resetResults = () => {
    personsActions.setFrom()
  }

  const sortByFieldType = (field) => {
    setSortField(field)
    let newSort = ''
    switch (field) {
      case 'GENDER': {
        setLifespanSortFieldIndex(-1)
        const newIndex = genderSortFieldIndex === 2 ? 0 : genderSortFieldIndex + 1
        setGenderSortFieldIndex(newIndex)
        newSort = genderSortFields[newIndex]
        break
      }
      case 'LIFESPAN_BEGIN': {
        setGenderSortFieldIndex(-1)
        const newIndex = lifespanSortFieldIndex === 2 ? 0 : lifespanSortFieldIndex + 1
        setLifespanSortFieldIndex(newIndex)
        newSort = lifespanSortFields[newIndex]
        break
      }
      default: {
        setGenderSortFieldIndex(-1)
        setLifespanSortFieldIndex(-1)
        newSort = field
        if (sortField === field) {
          // it is already selected, change direction
          const newDirection = !sortAsc
          setSortAsc(!sortAsc)
          newSort = `${newSort}_${newDirection ? 'ASC' : 'DESC'}`
        } else {
          newSort = `${newSort}_ASC`
        }
      }
    }

    // needed so we fetch from the beginning
    resetResults()
    personsActions.setSort(newSort)
  }

  return {
    sortField,
    sortAsc,
    genderSortFieldIndex,
    lifespanSortFieldIndex,
    genderSortFields,
    lifespanSortFields,
    sortByFieldType,
    resetResults,
  }
}
